var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnOddodd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 313.53 150.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-3, .cls-5, .cls-8, .cls-10, .cls-13, .cls-20 {\n        isolation: isolate;\n      }\n\n      .cls-3, .cls-13, .cls-20 {\n        opacity: .5;\n      }\n\n      .cls-28 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-9);\n      }\n\n      .cls-5, .cls-8, .cls-10 {\n        opacity: .3;\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-13);\n      }\n\n      .cls-9 {\n        fill: #6171e5;\n      }\n\n      .cls-10 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-11 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-15 {\n        fill: url(#radial-gradient-11);\n      }\n\n      .cls-16 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-17 {\n        fill: #e57361;\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-21 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-32 {\n        fill: none;\n      }\n\n      .cls-22 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-23 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-24 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-26 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-27 {\n        fill: #c5dfff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 502.15,
    y: 0,
    width: 157.24,
    height: 150.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 568.75,
    y1: -904.02,
    x2: 261.13,
    y2: -596.39,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001e8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 560.85,
    y1: -896.12,
    x2: 269.03,
    y2: -604.29,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0933ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b51e3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 206.03,
    cy: -670.26,
    fx: 206.03,
    fy: -670.26,
    r: 449.57,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0019b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 207.23,
    cy: -807.15,
    fx: 207.23,
    fy: -807.15,
    r: 463.13,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ad6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 215.29,
    cy: -672.72,
    fx: 215.29,
    fy: -672.72,
    r: 379.04,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0019b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -215.5,
    cy: -797.66,
    fx: -215.5,
    fy: -797.66,
    r: 68.84,
    gradientTransform: "translate(1322.78 -675.42) scale(4.21 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0019b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 182.22,
    y1: -742.91,
    x2: 648.14,
    y2: -742.91,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0019b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    y: 0,
    width: 157.24,
    height: 150.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 398.26,
    y1: -904.02,
    x2: 90.64,
    y2: -596.39,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a0a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d40500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 390.36,
    y1: -896.12,
    x2: 98.53,
    y2: -604.29,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ba1309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e30f0b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 35.54,
    cy: -670.26,
    fx: 35.54,
    fy: -670.26,
    r: 449.57,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 36.73,
    cy: -807.15,
    fx: 36.73,
    fy: -807.15,
    r: 463.13,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6000a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -16.53,
    cy: -684.99,
    fx: -16.53,
    fy: -684.99,
    r: 170.43,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 7.04,
    y1: -770.33,
    x2: 7.04,
    y2: -681.39,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010d01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b01e09"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 44.8,
    cy: -672.72,
    fx: 44.8,
    fy: -672.72,
    r: 379.04,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -256.02,
    cy: -797.66,
    fx: -256.02,
    fy: -797.66,
    r: 68.84,
    gradientTransform: "translate(1322.78 -675.42) scale(4.21 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 11.73,
    y1: -726.56,
    x2: 477.65,
    y2: -726.56,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b01e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010d01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 156.3,
    y: 0,
    width: 157.24,
    height: 150.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 222.9,
    y1: -904.02,
    x2: -84.72,
    y2: -596.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 215,
    y1: -896.12,
    x2: -76.83,
    y2: -604.29,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -139.82,
    fx: -139.82,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -138.63,
    fx: -138.63,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 300,
    y1: -750.2,
    x2: 312.98,
    y2: -750.2,
    gradientTransform: "translate(0 -675.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ad6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: -130.56,
    fx: -130.56,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: -297.7,
    fx: -297.7,
    r: 68.84,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -163.64,
    x2: 302.29,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m188.36.89h453.15c9.56.02,17.3,7.76,17.32,17.32v113.16c-.02,9.56-7.76,17.3-17.32,17.32H188.36c-9.56-.02-17.3-7.76-17.32-17.32V18.2c0-4.59,1.83-8.99,5.08-12.23,3.24-3.25,7.64-5.08,12.23-5.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m188.36,12.06c-1.63,0-3.19.65-4.34,1.81-1.16,1.15-1.81,2.71-1.81,4.34v113.16c.02,3.39,2.76,6.13,6.14,6.14h453.15c3.39-.02,6.13-2.76,6.14-6.14V18.2c-.02-3.39-2.76-6.13-6.14-6.14H188.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m188.36,12.06h453.15c1.63,0,3.19.65,4.34,1.81l7.9-7.9c-3.24-3.25-7.64-5.08-12.23-5.08H188.36c-4.59,0-8.99,1.83-12.23,5.08l7.9,7.9c1.15-1.16,2.71-1.81,4.34-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m641.52,137.5H188.36c-1.63,0-3.19-.65-4.34-1.81l-7.9,7.9c3.24,3.25,7.64,5.08,12.23,5.08h453.15c4.59,0,8.99-1.83,12.23-5.08l-7.9-7.9c-1.15,1.16-2.71,1.81-4.34,1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m641.52,2.56H188.36c-4.15,0-8.12,1.65-11.05,4.59-2.94,2.93-4.59,6.9-4.59,11.05v72.3c0,5.14,7.82,5.14,7.82,0V18.2c0-2.07.83-4.06,2.3-5.52,1.46-1.47,3.45-2.3,5.52-2.3h453.15c4.31.02,7.8,3.51,7.82,7.82v16.9c0,5.14,7.82,5.14,7.82,0v-16.9c-.02-8.63-7.01-15.62-15.64-15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m343.43,8.85c-84.23,0-152.51,1.02-152.51,1.54s125.76.47,152.51.47,152.51.05,152.51-.47-68.28-1.54-152.51-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m415.18,143.1c-125.52,0-227.27-2.16-227.27-3.25s187.4-.98,227.27-.98,227.27-.11,227.27.98c0,.81-56.41,2.03-136.97,2.7-27.69.23-58.18.55-90.29.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m182.22,122.92c40.91-7.84,198.9-30.68,321.95-49.96,65.65-10.29,121.59-20.44,143.97-24.84v-27.34c0-4.78-2.77-8.71-6.14-8.71H188.36c-1.78.09-3.4,1.05-4.34,2.56-1.21,1.82-1.84,3.96-1.81,6.15v102.14Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.87.89h453.15c9.56.02,17.3,7.76,17.32,17.32v113.16c-.02,9.56-7.76,17.3-17.32,17.32H17.87c-9.56-.02-17.3-7.76-17.32-17.32V18.2C.57,8.65,8.31.91,17.87.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m17.87,12.06c-3.39.02-6.13,2.76-6.14,6.14v113.16c.02,3.39,2.76,6.13,6.14,6.14h453.15c3.39-.02,6.13-2.76,6.14-6.14V18.2c-.02-3.39-2.76-6.13-6.14-6.14H17.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m17.87,12.06h453.15c1.63,0,3.19.65,4.34,1.81l7.9-7.9c-3.24-3.25-7.64-5.08-12.23-5.08H17.87c-4.59,0-8.99,1.83-12.23,5.08l7.9,7.9c1.15-1.15,2.71-1.81,4.34-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m471.02,137.5H17.87c-1.63,0-3.19-.65-4.34-1.81l-7.9,7.9c3.24,3.25,7.64,5.08,12.23,5.08h453.15c4.59,0,8.99-1.83,12.23-5.08l-7.9-7.9c-1.15,1.15-2.71,1.81-4.34,1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m11.73,131.36V18.2c0-1.63.65-3.19,1.81-4.34l-7.9-7.9C2.38,9.21.55,13.61.56,18.2v113.16c0,4.59,1.83,8.99,5.08,12.23l7.9-7.9c-1.15-1.15-1.81-2.71-1.81-4.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m11.73,90.22V18.2c0-1.63.65-3.19,1.81-4.34l-7.9-7.9C2.38,9.21.55,13.61.56,18.2v76.71c1.97-1.92,8.19-4.44,11.17-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m471.02,2.56H17.87c-8.63.02-15.62,7.01-15.64,15.64v72.3c0,5.14,7.82,5.14,7.82,0V18.2c.02-4.31,3.51-7.8,7.82-7.82h453.15c4.31.02,7.8,3.51,7.82,7.82v16.9c0,5.14,7.82,5.14,7.82,0v-16.9c-.02-8.63-7.01-15.62-15.64-15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m8.24,142.3c1.16-1.72,2.59-3.23,4.25-4.47.86-.54,1.85-.84,2.87-.86-1.73-.79-3.01-2.32-3.46-4.16.2,1.33-.03,2.68-.67,3.86-1.16,1.72-2.59,3.23-4.25,4.47-.87.57-1.93.79-2.96.6,1.07,1.42,2.35,2.67,3.8,3.71-.28-1.06-.13-2.2.42-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m8.24,7.27c1.16,1.72,2.59,3.23,4.25,4.47.86.54,1.85.84,2.87.87-1.73.78-3.01,2.32-3.46,4.16.2-1.33-.03-2.68-.67-3.86-1.16-1.72-2.59-3.23-4.25-4.47-.87-.57-1.93-.79-2.96-.6,1.07-1.42,2.35-2.67,3.8-3.71-.28,1.06-.13,2.19.42,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m244.69,143.1c-125.52,0-227.27-2.16-227.27-3.25s187.4-.98,227.27-.98,227.27-.11,227.27.98-101.75,3.25-227.27,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m11.73,90.22c62.74-8.48,401.58-43.82,465.92-52.74v-19.28c-.02-3.39-2.76-6.13-6.14-6.14H17.87c-3.39.02-6.13,2.76-6.14,6.14v72.01Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m-157.49.89h453.15c9.56.02,17.3,7.76,17.32,17.32v113.16c-.02,9.56-7.76,17.3-17.32,17.32H-157.49c-9.56-.02-17.3-7.76-17.32-17.32V18.2c0-4.59,1.83-8.99,5.08-12.23,3.24-3.25,7.64-5.08,12.23-5.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m-157.49,12.06c-1.63,0-3.19.65-4.34,1.81-1.16,1.15-1.81,2.71-1.81,4.34v113.16c.02,3.39,2.76,6.13,6.14,6.14h453.15c3.39-.02,6.13-2.76,6.14-6.14V18.2c-.02-3.39-2.76-6.13-6.14-6.14H-157.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m-157.49,12.06h453.15c1.63,0,3.19.65,4.34,1.81l7.9-7.9c-3.24-3.25-7.64-5.08-12.23-5.08H-157.49c-4.59,0-8.99,1.83-12.23,5.08l7.9,7.9c1.15-1.16,2.71-1.81,4.34-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m295.66,137.5H-157.49c-1.63,0-3.19-.65-4.34-1.81l-7.9,7.9c3.24,3.25,7.64,5.08,12.23,5.08h453.15c4.59,0,8.99-1.83,12.23-5.08l-7.9-7.9c-1.15,1.16-2.71,1.81-4.34,1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m301.81,18.2v113.16c0,1.63-.65,3.19-1.81,4.34l7.9,7.9c3.25-3.24,5.08-7.64,5.08-12.23V18.2c0-4.59-1.83-8.99-5.08-12.23l-7.9,7.9c1.15,1.15,1.81,2.71,1.81,4.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m295.66,2.56H-157.49c-4.15,0-8.12,1.65-11.05,4.59-2.94,2.93-4.59,6.9-4.59,11.05v72.3c0,5.14,7.82,5.14,7.82,0V18.2c0-2.07.83-4.06,2.3-5.52,1.46-1.47,3.45-2.3,5.52-2.3h453.15c4.31.02,7.8,3.51,7.82,7.82v16.9c0,5.14,7.82,5.14,7.82,0v-16.9c-.02-8.63-7.01-15.62-15.64-15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m-2.42,8.85c-84.23,0-152.51,1.02-152.51,1.54s125.76.47,152.51.47,152.51.05,152.51-.47-68.28-1.54-152.51-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m305.29,142.3c-1.16-1.72-2.59-3.23-4.25-4.47-.86-.54-1.85-.84-2.87-.86,1.73-.78,3.01-2.32,3.46-4.16-.2,1.33.03,2.68.67,3.86,1.16,1.72,2.59,3.23,4.25,4.47.87.57,1.93.79,2.96.6-1.07,1.42-2.35,2.67-3.8,3.71.28-1.06.13-2.2-.42-3.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m305.29,7.27c-1.16,1.72-2.59,3.23-4.25,4.47-.86.54-1.85.84-2.87.86,1.73.79,3.01,2.32,3.46,4.16-.2-1.33.03-2.68.67-3.86,1.16-1.72,2.59-3.23,4.25-4.47.87-.57,1.93-.79,2.96-.6-1.07-1.42-2.35-2.67-3.8-3.71.28,1.06.13,2.2-.42,3.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m69.33,143.1c-125.52,0-227.27-2.16-227.27-3.25s187.4-.98,227.27-.98,227.27-.11,227.27.98c0,.81-56.41,2.03-136.97,2.7-27.69.23-58.18.55-90.29.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m-163.63,122.92c40.91-7.84,198.9-30.68,321.95-49.96,65.65-10.29,121.59-20.44,143.97-24.84v-27.34c0-4.78-2.77-8.71-6.14-8.71H-157.49c-1.78.09-3.4,1.05-4.34,2.56-1.21,1.82-1.84,3.96-1.81,6.15v102.14Z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m37.14,91.74c-2.92-1.65-5.25-3.92-6.96-6.83-1.72-2.91-2.57-6.18-2.57-9.83s.86-6.92,2.57-9.82c1.72-2.91,4.04-5.18,6.96-6.8,2.92-1.63,6.14-2.44,9.64-2.44s6.71.81,9.61,2.44c2.91,1.63,5.21,3.9,6.91,6.8,1.7,2.91,2.55,6.18,2.55,9.82s-.85,6.92-2.55,9.83c-1.7,2.91-4.01,5.18-6.94,6.83-2.92,1.65-6.12,2.47-9.59,2.47s-6.72-.82-9.64-2.47Zm15-10.64c1.26-1.49,1.89-3.49,1.89-6.02s-.63-4.58-1.89-6.07c-1.26-1.49-3.05-2.23-5.36-2.23s-4.15.74-5.41,2.23c-1.26,1.49-1.89,3.51-1.89,6.07s.63,4.53,1.89,6.02c1.26,1.49,3.06,2.23,5.41,2.23s4.1-.74,5.36-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m93.93,59.01c2.92,1.58,5.18,3.77,6.75,6.57,1.58,2.8,2.36,5.99,2.36,9.56s-.79,6.72-2.36,9.56c-1.58,2.84-3.83,5.07-6.75,6.7-2.92,1.63-6.33,2.44-10.22,2.44h-15.5v-37.2h15.5c3.89,0,7.29.79,10.22,2.36Zm-5.02,22.28c1.54-1.44,2.31-3.49,2.31-6.15s-.77-4.71-2.31-6.15c-1.54-1.44-3.62-2.15-6.25-2.15h-2.78v16.6h2.78c2.63,0,4.71-.72,6.25-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m131.13,59.01c2.92,1.58,5.18,3.77,6.75,6.57,1.58,2.8,2.36,5.99,2.36,9.56s-.79,6.72-2.36,9.56c-1.58,2.84-3.83,5.07-6.75,6.7-2.92,1.63-6.33,2.44-10.22,2.44h-15.5v-37.2h15.5c3.89,0,7.29.79,10.22,2.36Zm-5.02,22.28c1.54-1.44,2.31-3.49,2.31-6.15s-.77-4.71-2.31-6.15c-1.54-1.44-3.62-2.15-6.25-2.15h-2.78v16.6h2.78c2.63,0,4.71-.72,6.25-2.15Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m184.49,91.74c-2.92-1.65-5.25-3.92-6.96-6.83-1.72-2.91-2.57-6.18-2.57-9.83s.86-6.92,2.57-9.82c1.72-2.91,4.04-5.18,6.96-6.8,2.92-1.63,6.14-2.44,9.64-2.44s6.71.81,9.62,2.44c2.91,1.63,5.21,3.9,6.91,6.8s2.55,6.18,2.55,9.82-.85,6.92-2.55,9.83-4.01,5.18-6.94,6.83c-2.92,1.65-6.12,2.47-9.59,2.47s-6.72-.82-9.64-2.47Zm15-10.64c1.26-1.49,1.89-3.49,1.89-6.02s-.63-4.58-1.89-6.07c-1.26-1.49-3.05-2.23-5.36-2.23s-4.15.74-5.41,2.23c-1.26,1.49-1.89,3.51-1.89,6.07s.63,4.53,1.89,6.02c1.26,1.49,3.06,2.23,5.41,2.23s4.1-.74,5.36-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m241.28,59.01c2.92,1.58,5.17,3.77,6.75,6.57,1.58,2.8,2.36,5.99,2.36,9.56s-.79,6.72-2.36,9.56c-1.58,2.84-3.83,5.07-6.75,6.7-2.92,1.63-6.33,2.44-10.22,2.44h-15.5v-37.2h15.5c3.89,0,7.29.79,10.22,2.36Zm-5.02,22.28c1.54-1.44,2.31-3.49,2.31-6.15s-.77-4.71-2.31-6.15c-1.54-1.44-3.62-2.15-6.25-2.15h-2.78v16.6h2.78c2.63,0,4.71-.72,6.25-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m278.48,59.01c2.92,1.58,5.17,3.77,6.75,6.57,1.58,2.8,2.36,5.99,2.36,9.56s-.79,6.72-2.36,9.56c-1.58,2.84-3.83,5.07-6.75,6.7-2.92,1.63-6.33,2.44-10.22,2.44h-15.5v-37.2h15.5c3.89,0,7.29.79,10.22,2.36Zm-5.02,22.28c1.54-1.44,2.31-3.49,2.31-6.15s-.77-4.71-2.31-6.15c-1.54-1.44-3.62-2.15-6.25-2.15h-2.78v16.6h2.78c2.63,0,4.71-.72,6.25-2.15Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnOddodd);
export default __webpack_public_path__ + "static/media/btn_oddodd.004d90cb5295e5140ef00d9144231802.svg";
export { ForwardRef as ReactComponent };